<template>
  <Modal
    v-if="show"
    :config="getPaymentSuccessDialogConfig"
    @btn1Action="internalError ? $emit('routeToDashboard') : retry ? $emit('retryTransfer') : $emit('cancelTransfer')"
    @btn2Action="internalError ? null : $emit('goBack')">
    <span v-if="internalError" slot="modalContent" class="text-subtitle-1 font-weight-medium" data-qa="paymentfailuredialog-span-1qclyp">
      {{ resource.internalErrorSubtitle }}
    </span>
    <span v-else slot="modalContent" class="text-subtitle-1 font-weight-medium" data-qa="paymentfailuredialog-span-g9iuvo">
      <div data-qa="paymentfailuredialog-div-wc7009">
        <p class="text-subtitle-1 font-weight-medium" data-qa="paymentfailuredialog-p-cq7aks">{{ resource.retrySubtitle1 }}</p>
      </div>
      <div v-for="(error, index) in errorList" :key="index" :data-qa="`paymentfailuredialog-div-o95ac-${index}`">
        <p class="text-body-2 red--text mb-0" :data-qa="`paymentfailuredialog-p-x7cry8-${index}`">
          <v-icon left color="red" :data-qa="`paymentfailuredialog-icon-08e4s-${index}`">mdi-circle-small</v-icon>
          {{ error }}
        </p>
      </div>
      <br data-qa="paymentfailuredialog-br-gv75yt"  />
      <div v-if="retry" data-qa="paymentfailuredialog-div-u57uph">
        <p class="text-body-1" data-qa="paymentfailuredialog-p-6fq9r">{{ resource.retrySubtitle2 }}</p>
      </div>
      <div v-else data-qa="paymentfailuredialog-div-sklru">
        <p class="text-subtitle-1 font-weight-medium" data-qa="paymentfailuredialog-p-cl2pbh">{{ resource.cancelSubtitle1 }}</p>
        <p class="text-body-2" data-qa="paymentfailuredialog-p-tiil8o">{{ resource.cancelSubtitle2 }}</p>
      </div>
    </span>
  </Modal>
</template>

<script>
export default {
  name: 'PaymentFailureDialog',
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  props: {
    show: Boolean,
    retry: Boolean,
    internalError: Boolean,
    errorList: Array
  },
  data () {
    return {
      modalConfig: {
        enabled: false,
        persistent: true,
        width: 700
      }
    }
  },
  computed: {
    resource () {
      return {
        title: this.$t('paymentFailureDialog.title'),
        retrySubtitle1: this.$t('paymentFailureDialog.retrySubtitle1'),
        retrySubtitle2: this.$t('paymentFailureDialog.retrySubtitle2'),
        cancelSubtitle1: this.$t('paymentFailureDialog.cancelSubtitle1'),
        cancelSubtitle2: this.$t('paymentFailureDialog.cancelSubtitle2'),
        internalError: this.$t('localPayments.confirm.fail.internalError'),
        internalErrorSubtitle: this.$t('localPayments.confirm.fail.internalErrorSub'),
        button: {
          back: this.$t('paymentFailureDialog.button.back'),
          retry: this.$t('paymentFailureDialog.button.retry'),
          cancel: this.$t('paymentFailureDialog.button.cancel'),
          goToDashboard: this.$t('paymentFailureDialog.button.gotoDashboard')
        }
      }
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig,
        enabled: this.show,
        title: this.internalError ? this.resource.internalError : this.resource.title,
        btn1Label: this.internalError ? this.resource.button.goToDashboard : this.retry ? this.resource.button.retry : this.resource.button.cancel,
        btn2Label: this.internalError ? null : this.resource.button.back
      }
    }
  }
}
</script>
